import { withTheme } from 'foundations-theming/utils';
import { Component } from 'react';
import I18n from 'I18n';
import { connect } from 'react-redux';
import partial from 'transmute/partial';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import * as PDFActions from '../../actions/PDFActions';
import { getDarkBrandingColor } from '../../utils/color';
import { isChirpEnabled } from '../../utils/isChirpEnabled';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import ViewPageDrawerItem from './ViewPageDrawerItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ABOVE_FOLD_ITEMS = 5;
class ViewPageDrawerWithoutTheme extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      limitLoadedSlides: true
    };
    this.getBrandingColor = () => {
      var _this$props$sharedLin, _this$props$sharedLin2, _this$props$presentat, _this$props$presentat2;
      const isUngatedToChirp = isChirpEnabled();
      const {
        primaryColor,
        secondaryColor
      } = isUngatedToChirp ? {
        primaryColor: (_this$props$sharedLin = this.props.sharedLink) === null || _this$props$sharedLin === void 0 || (_this$props$sharedLin = _this$props$sharedLin.brandingMetadata) === null || _this$props$sharedLin === void 0 ? void 0 : _this$props$sharedLin.primaryColor,
        secondaryColor: (_this$props$sharedLin2 = this.props.sharedLink) === null || _this$props$sharedLin2 === void 0 || (_this$props$sharedLin2 = _this$props$sharedLin2.brandingMetadata) === null || _this$props$sharedLin2 === void 0 ? void 0 : _this$props$sharedLin2.secondaryColor
      } : {
        primaryColor: (_this$props$presentat = this.props.presentation) === null || _this$props$presentat === void 0 || (_this$props$presentat = _this$props$presentat.brandingMetadata) === null || _this$props$presentat === void 0 ? void 0 : _this$props$presentat.primaryColor,
        secondaryColor: (_this$props$presentat2 = this.props.presentation) === null || _this$props$presentat2 === void 0 || (_this$props$presentat2 = _this$props$presentat2.brandingMetadata) === null || _this$props$presentat2 === void 0 ? void 0 : _this$props$presentat2.secondaryColor
      };
      return getDarkBrandingColor(primaryColor !== null && primaryColor !== void 0 ? primaryColor : null, secondaryColor !== null && secondaryColor !== void 0 ? secondaryColor : null, this.props.theme.color['fill-accent-neutral-default']);
    };
    this.handleChangePageClick = index => {
      const {
        changePage,
        changePageCHIRP,
        pageNumber: leavingPageNumber
      } = this.props;
      const element = document.getElementById(MAIN_CONTENT_ANCHOR);
      if (element) element.focus();
      if (isChirpEnabled()) {
        const enteringPageNumber = index + 1;
        changePageCHIRP({
          leavingPageNumber,
          enteringPageNumber
        });
        changePage(index);
      } else {
        changePage(index);
      }
    };
    this.renderSlides = () => {
      var _sharedLink$pages, _presentation$slides;
      const {
        presentation,
        sharedLink,
        pageIndex
      } = this.props;
      const {
        limitLoadedSlides
      } = this.state;
      const isUngatedToChirp = isChirpEnabled();
      const slides = isUngatedToChirp ? (_sharedLink$pages = sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.pages) !== null && _sharedLink$pages !== void 0 ? _sharedLink$pages : [] : (_presentation$slides = presentation === null || presentation === void 0 ? void 0 : presentation.slides) !== null && _presentation$slides !== void 0 ? _presentation$slides : [];
      const slidesToRender = limitLoadedSlides ? slides.slice(0, ABOVE_FOLD_ITEMS) : slides;
      return slidesToRender.map((slide, index) => {
        var _slide$thumbnailUrl;
        return /*#__PURE__*/_jsx(ViewPageDrawerItem, {
          brandingColor: this.getBrandingColor(),
          selected: pageIndex === index,
          imageUrl: (_slide$thumbnailUrl = slide.thumbnailUrl) !== null && _slide$thumbnailUrl !== void 0 ? _slide$thumbnailUrl : undefined,
          index: index,
          onClick: partial(this.handleChangePageClick, index)
        }, index);
      });
    };
    this.renderLoading = () => {
      var _sharedLink$pages2, _presentation$slides2;
      const {
        presentation,
        sharedLink
      } = this.props;
      const {
        limitLoadedSlides
      } = this.state;
      const isUngatedToChirp = isChirpEnabled();
      const slides = isUngatedToChirp ? (_sharedLink$pages2 = sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.pages) !== null && _sharedLink$pages2 !== void 0 ? _sharedLink$pages2 : [] : (_presentation$slides2 = presentation === null || presentation === void 0 ? void 0 : presentation.slides) !== null && _presentation$slides2 !== void 0 ? _presentation$slides2 : [];
      if (limitLoadedSlides && slides.length > ABOVE_FOLD_ITEMS) {
        return /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            layout: "centered"
          })
        });
      }
      return null;
    };
    this.renderDrawer = () => {
      return /*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(View, {
          overflowX: "hidden",
          overflowY: "auto",
          backgroundColor: "fill-surface-default",
          boxShadow: "100",
          "data-test-id": "view-page-drawer-container",
          children: /*#__PURE__*/_jsxs(Flex, {
            "aria-label": I18n.text('a11y.pageSelectorContainer'),
            padding: "400",
            backgroundColor: "fill-surface-default",
            flexDirection: "column",
            position: "relative",
            children: [this.renderSlides(), this.renderLoading()]
          })
        })
      });
    };
  }
  componentDidMount() {
    setTimeout(() => this.setState({
      limitLoadedSlides: false
    }), 1000);
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      children: this.props.open ? this.renderDrawer() : null
    });
  }
}
const ViewPageDrawer = withTheme(ViewPageDrawerWithoutTheme);
export default connect(state => ({
  pageIndex: state.view.pdf.pageIndex,
  pageNumber: state.view.pdf.pageIndex + 1
}), {
  changePage: PDFActions.changePage,
  changePageCHIRP: PDFActions.changePageCHIRP
})(ViewPageDrawer);